import { useTranslation } from "react-i18next";

const FilterMoment = () => {
  const { t } = useTranslation();
  return (
    <div className="main__content" id="main__content__v2">
      <div className="item3">
        <div className=" text__content" id="item3__text_content">
          <p>
            {t("filter__moment_content_1")}
            <strong>{t("filter__moment_content_2")}</strong>
            {t("filter__moment_content_3")}
            <br />
            {t("filter__moment_content_4")}
            <br />
          </p>
          <p>
            {t("filter__moment_content_5")}
            <strong>{t("filter__moment_content_6")}</strong>
            {t("filter__moment_content_7")}
          </p>
        </div>
      </div>
    </div>
  );
};
export default FilterMoment;
